// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"84048ced","397":"c88bf178"}[chunkId] + ".chunk.css";
};